<!--
* @Description:相关调研3
* @optionData
* @Date: 2024-01-09 14:33:01
-->
<template>
  <div
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="scale-circle" ref="ContentRef">
      <div class="circle">
        <div class="circle-content">
          <div
            v-for="(item, index) in data.tipData"
            :class="`circle-content-item${index + 1}`"
            id="circle"
            :key="index"
          >
            <span></span>

            <!-- <span>{{ sequence[index] }}</span> -->
          </div>
          <div class="circle-content-center">
            <div class="circle-content-center2">
              <div style="position: absolute; left: 0; right: 0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  viewBox="0 0 80 80"
                >
                  <path
                    id="liuchengguanli"
                    d="M104.782,112a3.536,3.536,0,0,1,3.535,3.536v11.785a3.535,3.535,0,0,1-3.535,3.536H97.974v2.226h9.64a5.491,5.491,0,0,1,5.482,5.409v4.019h4.779a3.536,3.536,0,0,1,3.535,3.536v7.988a3.535,3.535,0,0,1-3.535,3.536H104.913a3.536,3.536,0,0,1-3.535-3.536v-7.988a3.535,3.535,0,0,1,3.535-3.536h4.779v-3.928a2.087,2.087,0,0,0-2.037-2.095H84.8a2.087,2.087,0,0,0-2.078,2.053v3.97H87.5a3.536,3.536,0,0,1,3.535,3.536v7.988A3.535,3.535,0,0,1,87.5,157.57H74.535A3.535,3.535,0,0,1,71,154.034v-7.988a3.535,3.535,0,0,1,3.535-3.536h4.779v-3.928a5.492,5.492,0,0,1,5.392-5.5h9.862v-2.226H86.713a3.535,3.535,0,0,1-3.535-3.536V115.536A3.536,3.536,0,0,1,86.713,112h18.07Z"
                    transform="translate(-58 -90)"
                  />
                </svg>
              </div>

              <!-- <div>患者性别</div> -->
            </div>
          </div>
        </div>
        <!-- 提示 -->
        <div class="circle-tips">
          <div class="circle-tips-line">
            <div
              v-for="(item, index) in data.tipData.length"
              :class="`circle-tips-line-item${index + 1}`"
              :key="index"
              id="tips-line"
            ></div>
          </div>
        </div>
        <!-- 提示信息 -->
        <div class="text">
          <div
            v-for="(item, index) in data.tipData"
            :class="`text-tips-item${index + 1}`"
            :key="index"
          >
            <div :class="`text-tips-item${index + 1}-box`" id="tips-text">
              <div :class="`text-tips-item${index + 1}-box-bg`"></div>
              <div :class="`text-tips-item${index + 1}-box-text`">
                <div :class="`text-tips-item${index + 1}-box-text-div`">
                  <div v-for="(citem, cindex) in item" :key="cindex">
                    <span>{{ citem.label }}：</span>
                    {{ citem.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 项目名称 -->

      <div class="content-name">
        <div>
          <div
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
            v-for="(item, index) in data.projectName"
            :key="index"
          >
            <div class="block-color"></div>
            <!-- <div>{{ sequence[index] }}</div> -->
            <div>{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref, defineProps } from 'vue';
import {
  pcModulePatientSex1,
  selfAdaption,
  useDataAssembly
  // sequence
} from './hooks';
const props = defineProps<{
  tableHeaderList: Array<{ label: Array<string>; prop: string }>;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();
let data = useDataAssembly(props.tableHeaderList, props.tableDataList);
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);

onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  pcModulePatientSex1(TaskRef.value);
});
</script>

<style lang="scss" scoped>
@import '@/styles/theme.scss';
@import './index.scss';
.content-name {
  margin-top: 50px;
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  > div {
    display: flex;
    width: 80%;
    justify-content: center;

    > div {
      margin: 0 10px;
      display: flex;
      width: 100%;
      > div:nth-child(1) {
        margin-right: 5px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #0f0f0f;
      }
      > div:nth-child(2) {
        @include bottomText();
      }
    }
  }
}
.scale-circle {
  width: 1024px;
  height: 641px;
  margin: auto;
  display: grid;
  position: relative;
  // &-footer {
  //   position: absolute;
  //   bottom: 0;
  //   width: 100%;
  //   height: 113px;
  //   display: grid;
  //   &-content {
  //     margin: auto;
  //     margin-top: 53px;
  //     width: 100%;
  //     display: flex;
  //     justify-content: center;
  //     // align-items: center;
  //     &-project {
  //       margin: 0 10px;
  //       > div {
  //         display: flex;
  //         > div:nth-child(1) {
  //           margin-right: 5px;
  //           font-size: 14px;
  //           font-family: PingFang SC;
  //           font-weight: 600;
  //           color: #0f0f0f;
  //         }
  //         > div:nth-child(2) {
  //           @include bottomText();
  //         }
  //       }
  //     }
  //   }
  // }
}
.circle {
  --height: 490px;
  --width: 664.32px;
  width: var(--width);
  height: var(--height);
  transform-origin: center;
  // transform: scale(0.8);
  margin: 0 auto;
  margin-top: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  #liuchengguanli {
    display: block;
    fill: var(--theme-color-1, #000);
  }
  .text {
    position: absolute;
    width: 664.32px;
    height: 490px;
    &-tips-item1 {
      &-box {
        width: 189.66px;
        height: 117px;
        border-radius: 5%;
        border: 1px solid var(--theme-color-1, #000);
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        &-bg {
          position: absolute;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          opacity: $--opacityText;
          background-color: var(--theme-color-1, #000);
        }
        &-text {
          box-sizing: border-box;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          display: flex;
          justify-content: center;
          align-items: center;
          &-div {
            @include text();
          }
        }
      }
    }
    &-tips-item2 {
      &-box {
        width: 189.66px;
        height: 117px;
        border-radius: 5%;
        border: 1px solid var(--theme-color-2, #000);
        position: absolute;
        right: 0;
        top: 97px;
        &-bg {
          position: absolute;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          opacity: $--opacityText;
          background-color: var(--theme-color-2, #000);
        }
        &-text {
          box-sizing: border-box;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          display: flex;
          justify-content: center;
          align-items: center;
          &-div {
            @include text();
          }
        }
      }
    }
    &-tips-item3 {
      &-box {
        width: 189.66px;
        height: 117px;
        border-radius: 5%;
        border: 1px solid var(--theme-color-3, #000);
        position: absolute;
        right: 0;
        top: 283px;
        &-bg {
          position: absolute;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          opacity: $--opacityText;
          background-color: var(--theme-color-3, #000);
        }
        &-text {
          box-sizing: border-box;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          display: flex;
          justify-content: center;
          align-items: center;
          &-div {
            @include text();
          }
        }
      }
    }
    &-tips-item4 {
      &-box {
        width: 189.66px;
        height: 117px;
        border-radius: 5%;
        border: 1px solid var(--theme-color-4, #000);
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%);
        &-bg {
          position: absolute;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          opacity: $--opacityText;
          background-color: var(--theme-color-4, #000);
        }
        &-text {
          box-sizing: border-box;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          display: flex;
          justify-content: center;
          align-items: center;
          &-div {
            @include text();
          }
        }
      }
    }
    &-tips-item5 {
      &-box {
        width: 189.66px;
        height: 117px;
        border-radius: 5%;
        border: 1px solid var(--theme-color-5, #000);
        position: absolute;
        top: 283px;
        left: 0;
        &-bg {
          position: absolute;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          opacity: $--opacityText;
          background-color: var(--theme-color-5, #000);
        }
        &-text {
          box-sizing: border-box;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          display: flex;
          justify-content: center;
          align-items: center;
          &-div {
            @include text();
          }
        }
      }
    }
    &-tips-item6 {
      &-box {
        width: 189.66px;
        height: 117px;
        border-radius: 5%;
        border: 1px solid var(--theme-color-6, #000);
        position: absolute;
        top: 97px;
        left: 0;
        &-bg {
          position: absolute;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          opacity: $--opacityText;
          background-color: var(--theme-color-6, #000);
        }
        &-text {
          box-sizing: border-box;
          width: 189.66px;
          height: 117px;
          border-radius: 5%;
          display: flex;
          justify-content: center;
          align-items: center;
          &-div {
            @include text();
          }
        }
      }
    }
  }
  &-tips {
    position: absolute;
    width: 664.32px;
    height: 490px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: grid;
    &-line {
      margin: auto;
      width: 10%;
      height: 10%;
      position: relative;
      transform-origin: top left;
      transform: rotate(-90deg);
      &-item1 {
        transform-origin: top left;
        width: 104px;
        height: $--tipsLine;
        z-index: 2;
        background: var(--theme-color-1, #000);
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
      }
      &-item2 {
        transform-origin: top left;
        transform: rotate(60deg);
        width: 164px;
        height: $--tipsLine;
        z-index: 2;
        background: var(--theme-color-2, #000);
        position: absolute;
      }
      &-item3 {
        transform-origin: top left;
        transform: rotate(120deg);
        width: 165px;
        height: $--tipsLine;
        z-index: 2;
        background: var(--theme-color-3, #000);
        position: absolute;
      }
      &-item4 {
        transform-origin: top left;
        transform: rotate(180deg);
        width: 153px;
        height: $--tipsLine;
        z-index: 2;
        background: var(--theme-color-4, #000);
        position: absolute;
      }

      &-item5 {
        transform-origin: top left;
        transform: rotate(240deg);
        width: 165px;
        height: $--tipsLine;
        z-index: 2;
        background: var(--theme-color-5, #000);
        position: absolute;
      }
      &-item6 {
        transform-origin: top left;
        transform: rotate(300deg);
        width: 166px;
        height: $--tipsLine;
        z-index: 2;
        background: var(--theme-color-6, #000);
        position: absolute;
      }
    }
  }
  &-content {
    width: 210px;
    height: 210px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    z-index: 1;

    &-center {
      width: 100%;
      height: 100%;
    }
    &-center2 {
      width: 70%;
      height: 70%;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      text-align: center;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &-item1 {
      position: absolute;
      width: 60%;
      height: 50%;
      background-color: var(--theme-color-1, #000);
      transform-origin: bottom;
      transform: rotate(0deg);
      -webkit-clip-path: polygon(93% 0, 0 0, 50% 100%);
      clip-path: polygon(93% 0, 0, 50% 100%);
      span {
        position: absolute;
        left: 50%;
        top: 5%;
        color: #fff;
        font-weight: bold;
        display: inline-block;
      }
    }
    &-item2 {
      position: absolute;
      width: 60%;
      height: 50%;
      background-color: var(--theme-color-2, #000);
      transform-origin: bottom;
      transform: rotate(60deg);
      -webkit-clip-path: polygon(93% 0, 0 0, 50% 100%);
      clip-path: polygon(93% 0, 0, 50% 100%);
      span {
        transform: rotate(-60deg);
        position: absolute;
        left: 50%;
        top: 5%;
        color: #fff;
        font-weight: bold;
        display: inline-block;
      }
    }

    &-item3 {
      position: absolute;
      width: 60%;
      height: 50%;
      background-color: var(--theme-color-3, #000);
      transform-origin: bottom;
      transform: rotate(120deg);
      -webkit-clip-path: polygon(93% 0, 0 0, 50% 100%);
      clip-path: polygon(93% 0, 0, 50% 100%);
      span {
        transform: rotate(-120deg);
        position: absolute;
        left: 50%;
        top: 5%;
        color: #fff;
        font-weight: bold;
        display: inline-block;
      }
    }

    &-item4 {
      position: absolute;
      width: 60%;
      height: 50%;
      background-color: var(--theme-color-4, #000);
      transform-origin: bottom;
      transform: rotate(180deg);
      -webkit-clip-path: polygon(93% 0, 0 0, 50% 100%);
      clip-path: polygon(93% 0, 0, 50% 100%);
      span {
        transform: rotate(-180deg);
        position: absolute;
        left: 45%;
        top: 5%;
        color: #fff;
        font-weight: bold;
        display: inline-block;
      }
    }

    &-item5 {
      position: absolute;
      width: 60%;
      height: 50%;
      background-color: var(--theme-color-5, #000);
      transform-origin: bottom;
      transform: rotate(240deg);
      -webkit-clip-path: polygon(93% 0, 0 0, 50% 100%);
      clip-path: polygon(93% 0, 0, 50% 100%);
      span {
        transform: rotate(-240deg);
        position: absolute;
        left: 50%;
        top: 5%;
        color: #fff;
        font-weight: bold;
        display: inline-block;
      }
    }
    &-item6 {
      position: absolute;
      width: 60%;
      height: 50%;
      background-color: var(--theme-color-6, #000);
      transform-origin: bottom;
      transform: rotate(300deg);
      -webkit-clip-path: polygon(93% 0, 0 0, 50% 100%);
      clip-path: polygon(93% 0, 0, 50% 100%);
      span {
        transform: rotate(-300deg);
        position: absolute;
        left: 50%;
        top: 5%;
        color: #fff;
        font-weight: bold;
        display: inline-block;
      }
    }
  }
}
</style>
